import { render } from "./AiHelper.vue?vue&type=template&id=c72fd992&scoped=true"
import script from "./AiHelper.vue?vue&type=script&lang=js"
export * from "./AiHelper.vue?vue&type=script&lang=js"

import "./AiHelper.vue?vue&type=style&index=0&id=c72fd992&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72fd992"]])

export default __exports__